module.exports = __webpack_public_path__ + "img/metr.5c52c0c4.png";